<template>
  <div class="stream-tab-body">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="ended-session-widget">
      <div class="ended-session-item" v-for="(item, index) in sessions" :key="index">
        <div class="session-brand">
          <img :src="stream_cdn_server_url + '/watch.rw/' + item.sessionId + '/preview.webp'" class="session-cover">
          <div class="session-brand-overlay">
            <button @click="playVideo(item)" class="btn-play">
              <img src="@/assets/images/icons/play.svg">
            </button>
            <div class="video-time" v-if="item.status == 'completed' || item.status == 'uploaded'">
              {{ toHHMMSS(parseFloat(item.totalRecordTime)) }}
            </div>
            <div class="session-dropdown-options">
              <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left" animation="">
                <template #trigger>
                  <b-icon icon="dots-vertical"></b-icon>
                </template>
                <b-dropdown-item @click="setAsDefault(item)" aria-role="listitem">Set As Default</b-dropdown-item>
                <b-dropdown-item v-if="false" aria-role="listitem">Delete</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="session-middle-options">
          <div class="session-date">
            <span>{{ moment(item.createdAt).fromNow() }}</span>
          </div>
          <b-taglist attached>
            <b-tag type="is-primary" size="is-small" v-if="item.status == 'completed'" aria-close-label="Close tag">
              Completed
            </b-tag>
            <b-tag type="is-warning" size="is-small" v-if="item.status == 'progress'" aria-close-label="Close tag">
              In Progress
            </b-tag>
            <b-tag type="is-default" size="is-small" v-if="item.hlsPath == event.dumpedHlsPath"
              aria-close-label="Close tag">
              Default
            </b-tag>
          </b-taglist>
        </div>
        <div class="session-options">
          <div class="file-size" v-if="item.status == 'completed'">
          </div>
        </div>
      </div>
    </div>
    <!-- ClapprPlayer -->
    <b-modal v-model="show_player" v-if="selected_video_url" :width="800">
      <div style="height: 500px">
        <ClapprPlayer :src="selected_video_url" :type="'hls'"></ClapprPlayer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { MEDIA_SERVER_BASE_URL, STREAMING_CDN_SERVER_BASE_URL } from "@/store/variables.js";

export default {
  components: {},
  props: {
    event: {
      type: Object,
      required: true,
    },
    stream_key: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isLoading: true,
    sessions: [],
    selected_video_url: null,
    show_player: false,
    media_server_url: MEDIA_SERVER_BASE_URL,
    stream_cdn_server_url: STREAMING_CDN_SERVER_BASE_URL,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getStreamSessions();
  },
  methods: {
    setAsDefault(item) {
      let vm = this;
      vm.$store
        .dispatch("STREAMING_SET_DEFAULT_DEMPED_HLS", {
          event_id: vm.event.id,
          dumpedHlsPath: item.hlsPath
        })
        .then((response) => {
          vm.event.dumpedHlsPath = item.hlsPath;
          vm.$buefy.toast.open({
            message: "Settings updated",
            type: "is-success",
          });
        })
        .catch(({ response }) => {
        });
    },
    playVideo(item) {
      let vm = this;
      vm.selected_video_url = STREAMING_CDN_SERVER_BASE_URL + "/" + item.hlsPath;
      vm.show_player = true;
    },
    getStreamSessions() {
      let vm = this;
      vm.isLoading = true;
      vm.$store
        .dispatch("STREAMING_GET_STREAM_SESSIONS", {
          event_id: vm.event.id
        })
        .then((response) => {
          vm.isLoading = false;
          vm.sessions = response.data;
        })
        .catch(({ response }) => {
          vm.isLoading = false;
        });
    },

  },
};
</script>
<style lang="scss" scoped>
.stream-tab-body {
  height: calc(100% - 400px);
  width: 100%;
  overflow-y: auto;
  position: relative;

  .ended-session-widget {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: stretch;
    align-content: start;
    gap: 10px;
    padding: 10px;

    .ended-session-item {
      display: flex;
      justify-content: space-between;
      height: max-content;
      padding: 10px 10px;
      border: 1px solid #ddd;
      border-radius: 5px;

      &:hover {
        border: 1px solid #e0e0e0;
        background-color: #fafafa;
      }

      .session-brand {
        position: relative;
        height: 100px;

        .session-cover {
          width: 180px;
          height: 100%;
          object-fit: cover;
        }

        .session-brand-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0, 0, 0, 0.5);
          transition: all 0.3s ease;

          .btn-play {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.3s ease;

            &:hover {
              background: #ddd;
            }
          }

          .video-time {
            color: #fff;
            font-size: 12px;
            margin-left: 10px;
            position: absolute;
            bottom: 5px;
            right: 5px;

          }

          .session-dropdown-options {
            position: absolute;
            top: 5px;
            right: 5px;
            color: #fff;
          }
        }
      }



      .session-options {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        height: 100%;
        padding: 10px 0;

        .file-size {
          font-size: 12px;
          color: #999;
        }
      }

    }
  }
}
</style>